import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { ROUTER_NAME } from '../../router'
import { userState } from '../../stores/user'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderUser',
  setup(__props) {

const router = useRouter()

const user = computed(() => userState.user)

const tab = (page: string) => {
  router.push({ name: page })
}

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    icon: "",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (tab(_unref(ROUTER_NAME).MYPROFILE)), ["stop"])),
    class: "text-center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_avatar, {
        size: "25",
        class: "ms-4"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: 
          user.value && user.value.image
            ? user.value.image.url
            : '/assets/user-958851872d7a849ea34d9887d31e41ce820428c6fccef8cb62b595382379b407.png'
        ,
            style: {"width":"25px","height":"25px"}
          }, null, 8 /* PROPS */, _hoisted_1)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})